import React, { memo } from 'react';
import { Blok } from '../../../interfaces/Blok.interface';
import { StoryblokRichtext } from 'storyblok-rich-text-react-renderer';
import { withBlokWrapper } from '../../BlokWrapper/BlokWrapper';
import { Theme } from '../../../interfaces/enums/Theme.enum';
import RichText from '../../RichText/RichText';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { useMediaQuery } from 'react-responsive';

export interface FormFieldToolTipBlokProps extends Blok {
  title: string;
  body: StoryblokRichtext;
}

interface FormFieldToolTipProps {
  blok: FormFieldToolTipBlokProps;
  toggle: (state: boolean) => void;
}

const FormFieldToolTip: React.FC<FormFieldToolTipProps> = ({
  blok,
  toggle,
}) => {
  const { title, body } = blok;

  return (
    <div className="relative" {...storyblokEditable(blok)}>
      <div className="absolute top-4 z-[60] right-4 cursor-pointer scale-[1.3] hover:scale-[1.4] transition-all">
        <button
          className="h-[24px] w-[24px] bg-no-repeat bg-system/black"
          aria-label="close menu"
          onClick={() => toggle(false)}
          style={{
            WebkitMaskImage: "url('/svgs/close.svg')",
            maskImage: "url('/svgs/close.svg')",
          }}
        />
      </div>
      <div className="rounded-t-[12px] sm:rounded-[12px] overflow-hidden">
        <div className="flex flex-col items-start justify-start px-8 py-10 gap-y-6 overflow-scroll max-h-screen sm:max-h-none">
          {title && (
            <div className="flex items-center justify-center gap-x-3">
              <p className="font-dm-sans font-bold text-lg">{title}</p>
            </div>
          )}
          <RichText content={body} />
        </div>
      </div>
    </div>
  );
};

export default memo(withBlokWrapper(FormFieldToolTip, Theme.LIGHT));
